import { PlatformRequestData, PlatformRequestStatus, RequestType } from '@markant-platform/registration/model';
import { OrganizationType, QualificationLevel, SalutationType } from 'data-model';

export const MOCK_FURTHER_QUALIFICATION_REQUEST: PlatformRequestData = {
  id: 'platform-id',
  type: RequestType.FURTHER_QUALIFICATION_REQUEST,
  comments: [],
  user: {
    salutation: SalutationType.m,
    firstname: '',
    lastname: '',
    email: 'hello@world.pt',
    language: '',
  },
  organization: {
    organizationId: 'org-id',
    name: 'org-name',
    address: {
      street: 'org-street',
      streetNumber: '12',
      zipCode: '',
      city: '',
      countryCode: '',
    },
    gln: '123123123123',
    industry: null,
    salesTaxId: null,
    taxNumber: '132132',
    ezrCustomer: null,
    commercialRegisterId: null,
    organizationType: OrganizationType.SUPPLIER,
    targetQualificationLevel: QualificationLevel.LEVEL_3,
    phone: '+1232425',
  },
  originalOrganizationData: {
    organizationId: 'org-id',
    name: 'original-org-name',
    address: {
      street: 'original-org-street',
      streetNumber: '1',
      zipCode: '',
      city: '',
      countryCode: '',
    },
    gln: '123123123123',
    industry: null,
    salesTaxId: null,
    taxNumber: '132132',
    ezrCustomer: null,
    commercialRegisterId: null,
    organizationType: OrganizationType.SUPPLIER,
    targetQualificationLevel: QualificationLevel.LEVEL_3,
    phone: '+1232425',
  },
  platformRequestStatus: PlatformRequestStatus.PENDING,
  version: 1,
};
